import gql from 'graphql-tag';
import { UserProductDiscountFragment } from '../fragments';

export default gql`
mutation createUserProductDiscount (
    $user_id: ID!
    $is_active: Boolean!
    $discount: Float!
    $active_from: String!
    $active_to: String!
) {
    createUserProductDiscount (input: {
        user_id: $user_id,
        is_active: $is_active,
        discount: $discount,
        active_from: $active_from,
        active_to: $active_to,
    }) {
        ...UserProductDiscountFragment
    }
}
${UserProductDiscountFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createUserProductDiscount.ts